//
import { RFormFields } from '@/components/reusable_components/next'
import SlCustomerBranchOfficesModel from '@/models/Sale/SlCustomerBranchOffices'

//
export default RFormFields
	.from([
		{
			name: 'sl_customer_branch_offices_id',
			type: 'autocomplete-model',
			props: {
				itemText: 'address',
				itemValue: 'id',
				label: 'Sucursal',
				model: SlCustomerBranchOfficesModel,
				noDataText: 'Sin sucursales.',
				noObject: true,
				paramSearch: 'address',
			},
		},
		{
			name: 'number',
			type: 'text-field',
			props: {
				label: 'Folio',
			},
		},
		{
			name: 'recent',
			type: 'select',
			props: {
				label: 'Reciente',
				items: [
					{ value: '1', text: '1 días' },
					{ value: '5', text: '5 días' },
					{ value: '15', text: '15 días' },
					{ value: '30', text: '30 días' },
					{ value: '45', text: '45 días' },
					{ value: '60', text: '60 días' },
					{ value: '90', text: '90 días' },
					{ value: '120', text: '120 días' },
				],
			},
		}
	])
